/** @jsxImportSource @emotion/react */
"use client";

import type { ButtonProps, IconElement } from "@packages/ui";
import { Button, IconButton } from "@packages/ui";
import { cloneElement, forwardRef } from "react";

import { useMediaClass } from "../../../utils/media.emotion";

export type MediaButtonProps = Omit<ButtonProps, "size" | "color"> & {
  largeIcon: IconElement;
  smallIcon?: IconElement;
  size?: "s" | "l" | null;
};

export const MediaButton = forwardRef<HTMLButtonElement, MediaButtonProps>(
  (
    {
      largeIcon,
      smallIcon = largeIcon,
      onClick,
      size: buttonSize = null,
      ...props
    },
    ref,
  ) => {
    const mediaClass = useMediaClass();

    if (
      ((mediaClass.includes("expanded") || mediaClass.includes("fullscreen")) &&
        buttonSize !== "s") ||
      buttonSize === "l"
    ) {
      return (
        <Button
          variant={"transparentWhite"}
          onClick={onClick}
          ref={ref}
          {...props}
        >
          {cloneElement(largeIcon, { size: 80 })}
        </Button>
      );
    }

    return (
      <IconButton
        icon={smallIcon}
        onClick={onClick}
        variant={"transparentWhite"}
        ref={ref}
        {...props}
      />
    );
  },
);

MediaButton.displayName = "MediaButton";
